// extracted by mini-css-extract-plugin
export default {"subtitle":"index_subtitle__Yfraw","label":"index_label__FgH1W","icon":"index_icon__e6UVq"};